// extracted by mini-css-extract-plugin
module.exports = {"container":"_1BUVWffKA7ZvOB9WCFIjl2"};